<template>
  <div
    v-if="displayRecording"
  >
    <a
      v-show="showPlayButton"
      v-tooltip.left="'Play'"
      href="javascript:;"
      class="recording-cell__btn"
      @click="showAudioPlayer"
    >
      <i class="fa fa-play" />
    </a>
    <a
      v-show="!showPlayButton"
      v-tooltip.left="'Stop'"
      href="javascript:;"
      class="recording-cell__btn"
      @click="stopAudioPlayer"
    >
      <i class="red fa fa-stop" />
    </a>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  computed: {
    displayRecording() { 
      return this.params.node?.id && this.params.node?.data?.recordingUrl;
    },
    showPlayButton() {
      return !this.params.context?.componentParent?.showAudioPlayerForCall[this.params.node?.id];
    },
  },
  methods: {
    showAudioPlayer() {
      this.params.context?.componentParent?.showAudioPlayer(this.params.node?.data);
    },
    stopAudioPlayer() {
      this.params.context?.componentParent?.stopAudioPlayer(this.params.node?.data);
    }
  }
});
</script>

<style>

</style>